import _asyncToGenerator from "/data/landun/workspace/vft-activities/vip-activity/pages/cny2022-sport/node_modules/@vue/cli-plugin-babel/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/data/landun/workspace/vft-activities/vip-activity/pages/cny2022-sport/node_modules/@vue/cli-plugin-babel/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "regenerator-runtime/runtime.js";
import { mapState, mapActions } from 'vuex';
import { getRandomNoHitConfig } from '@/util';
export default {
  data: function data() {
    return {
      lotterying: false
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState(['remainNum'])), {}, {
    letfNum: function letfNum() {
      var _this$remainNum$vip;

      return (_this$remainNum$vip = this.remainNum.vip) !== null && _this$remainNum$vip !== void 0 ? _this$remainNum$vip : 0;
    }
  }),
  methods: _objectSpread(_objectSpread({}, mapActions(['getLotteryCount'])), {}, {
    lottery: function lottery() {
      var _arguments = arguments,
          _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var options, isClosePop, modId, _window$$aegis;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                options = _arguments.length > 0 && _arguments[0] !== undefined ? _arguments[0] : {};
                isClosePop = options.isClosePop;
                _context.prev = 2;

                if (_this.loginService.isLogin) {
                  _context.next = 6;
                  break;
                }

                _this.$openLogin();

                return _context.abrupt("return");

              case 6:
                if (!(_this.letfNum <= 0)) {
                  _context.next = 9;
                  break;
                }

                _this.toast('您当前没有领拜年礼物的机会哦~');

                return _context.abrupt("return");

              case 9:
                if (!_this.lotterying) {
                  _context.next = 11;
                  break;
                }

                return _context.abrupt("return");

              case 11:
                // 发起抽奖
                _this.lotterying = true;
                modId = _this.setting.魔方.抽奖.vip;
                _context.next = 15;
                return _this.magicService.doLottery({
                  module_id: modId
                }, function (data) {
                  var _data$prize_list;

                  _this.eventBus.$emit('showReward', {
                    result: true,
                    lottery: (_data$prize_list = data.prize_list) === null || _data$prize_list === void 0 ? void 0 : _data$prize_list[0]
                  }, isClosePop && _this.close);
                }, function () {
                  _this.eventBus.$emit('showReward', {
                    result: false,
                    lottery: getRandomNoHitConfig()
                  }, isClosePop && _this.close);
                });

              case 15:
                _this.lotterying = false; // 刷新抽奖次数

                _this.getLotteryCount();

                _context.next = 23;
                break;

              case 19:
                _context.prev = 19;
                _context.t0 = _context["catch"](2);
                _this.lotterying = false;
                (_window$$aegis = window.$aegis) === null || _window$$aegis === void 0 ? void 0 : _window$$aegis.reportEvent('[doLottery error]', _context.t0);

              case 23:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[2, 19]]);
      }))();
    }
  })
};